import { LoadState } from "../../constants/enums";
import { IAgentToolsState } from "./AgentTools.types";

export const initialAgentToolsState: IAgentToolsState = {
  registry: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
  mappings: {
    data: [],
    loading: LoadState.NotLoaded,
  },
};
